import { Tag } from "../../../../data/models/documentProperties/section";
import {
  ADD_SECTION_TAGS,
  DELETE_SECTION_TAG,
  SectionTagsActions,
  UPDATE_SECTION_TAG,
} from "../actions/sectionTags";

export type SectionTagsState = Tag[];

export const initialSectionTagsState: SectionTagsState = [];

export const sectionTags = (
  state: SectionTagsState = initialSectionTagsState,
  action: SectionTagsActions
): SectionTagsState => {
  switch (action.type) {
    case ADD_SECTION_TAGS:
      return state.concat(action.tags);
    case DELETE_SECTION_TAG:
      return state.filter((tag: Tag): boolean => tag.id !== action.tagId);
    case UPDATE_SECTION_TAG:
      return state.map(
        (tag: Tag): Tag => (tag.id === action.tag.id ? action.tag : tag)
      );
    default:
      return state;
  }
};
